
export const blurb3Config = {

      heading: "Clients",
      paragraph: "Our clients include both comedians and small to medium-sized businesses. We work with small businesses to promote."

};